import { useCallback } from 'react'

type PluralForms = {
  one: string
  other: string
  zero?: string
}

export const usePlural = () => {
  const getFormattedText = useCallback(
    (value: number | null | undefined, pluralForms: PluralForms) => {
      if (typeof value !== 'number') {
        return 'N/A'
      }

      const formatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })

      const pluralRules = new Intl.PluralRules('en-US')
      const pluralForm = pluralRules.select(value)

      const word =
        value === 0 && pluralForms.zero
          ? pluralForms.zero
          : pluralForms[pluralForm as keyof PluralForms] || pluralForms.other

      return `${formatter.format(value)} ${word}`
    },
    [],
  )

  return { getFormattedText }
}
